import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Button,
  Typography,
  TextField,
  Stack,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Icon } from '@iconify/react';
import Popover from '@mui/material/Popover';
import DialogActions from '@mui/material/DialogActions';
import Services from '../../services/Services';

// Adım başlıklarını dinamik olarak oluştur
function getSteps(docOrPackage) {
  const baseSteps = ['Kimden', 'Kime', 'Gönderi Türü', 'Gönderi İçeriği'];
  if (docOrPackage === 'Paket') {
    return [...baseSteps, 'Gümrük Bilgileri'];
  }
  return baseSteps;
}

export default function CargoOrderWizard() {
  const [activeTab, setActiveTab] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    sender: {
      name: 'Ahmet Yılmaz',
      company: 'Yılmaz Lojistik',
      country: 'Turkey',
      address1: 'İkitelli OSB Mah. 10. Cad. No:12',
      address2: '',
      address3: '',
      city: 'İstanbul',
      postalCode: '34306',
      email: 'ahmet.yilmaz@example.com',
      phoneCode: '+90',
      phone: '5551234567',
      tckn: '12345678901',
      saveInfo: false,
    },
    recipient: {
      name: 'Hans Müller',
      company: 'Müller GmbH',
      country: 'Germany',
      address1: 'Hauptstrasse 5',
      address2: '',
      address3: '',
      city: 'Berlin',
      postalCode: '10115',
      email: 'hans.muller@example.de',
      phoneCode: '+49',
      phone: '1712345678',
      tckn: 'DE123456789',
    },
    shipmentType: { name: '', price: '' },
    content: '',
    customsInfo: '',
    docOrPackage: 'Paket',
    extraProtection: 'Evet',
    items: [],
    isPerformaNeed: false,
    weight: '2.5',
    weightUnit: 'KG',
    length: '30',
    width: '20',
    height: '10',
    contentReference: '',
    contentDescription: '',
    otherComments: '',
    documentType: '',
    quoteReceiverCountry: 'Germany',
    quoteReceiverCity: 'Berlin',
    quoteReceiverPostalCode: '10115',
    quoteShipmentDate: new Date().toISOString().slice(0, 10),
    quoteShipmentValue: '50',
    quoteCurrency: 'EUR',
    quoteInsuredValue: '50',
    exportReason: 'GIFT', // Varsayılan değer
    exportInvoice: {
      date: new Date().toISOString().slice(0, 10), // Varsayılan olarak bugünün tarihi
      number: '',
      signatureName: '',
      signatureTitle: ''
    }
  });

  const noNeedPLTCountries = [
    "USA", "Germany"
  ]

  const [itemForm, setItemForm] = useState({
    packageType: '',
    description: '',
    quantity: '',
    netWeight: '',
    unitValue: '',
    originCountry: '',
  });
  // Kullanıcı ilk kez mi kullanıyor? (örnek state, gerçek uygulamada backend'den alınabilir)
  const [isFirstTimeUser] = useState(true); // false yaparsan "Kime" ile başlar
  const [isHizmetNoktasiChecked, setIsHizmetNoktasiChecked] = useState(false);

  // Fiyat sorgulama yapıldı mı?
  const [fiyatSorgulandi, setFiyatSorgulandi] = useState(false);

  const [selectedService, setSelectedService] = useState(null);
  const [apiProducts, setApiProducts] = useState([]);
  const [exchangeRates, setExchangeRates] = useState(null);

  const [showSummary, setShowSummary] = useState(false);
  const [showBildirSection, setShowBildirSection] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [supportTitle, setSupportTitle] = useState("");
  const [supportContent, setSupportContent] = useState("");
  const [showKabulModal, setShowKabulModal] = useState(false);
  const [isKabulEdildi, setIsKabulEdildi] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [openAccordion, setOpenAccordion] = useState('details');
  const [creationDate, setCreationDate] = useState(null);
  const [kabulTarihi, setKabulTarihi] = useState(null);
  const [showNotAcceptedModal, setShowNotAcceptedModal] = useState(false);
  const [descTooltipAnchor, setDescTooltipAnchor] = useState(null);
  const [showDescModal, setShowDescModal] = useState(false);
  const [descModalFields, setDescModalFields] = useState({
    product: '',
    brand: '',
    model: '',
    material: '',
    usage: '',
    description: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [shipmentResponse, setShipmentResponse] = useState(null);

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [paymentToken, setPaymentToken] = useState('');
  const [paymentTokenLoading, setPaymentTokenLoading] = useState(false);
  const [paymentTokenError, setPaymentTokenError] = useState('');
  const [paymentFormErrors, setPaymentFormErrors] = useState({});
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiredDate, setExpiredDate] = useState("");
  const [cvv, setCvv] = useState("");
  const [conversationID, setConversationID] = useState("");
  const [iframeSrc, setIframeSrc] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const intervalRef = useRef(null);
  const [orderLoading, setOrderLoading] = useState(false);

  const validateStep = (step) => {
    const newErrors = {};
    const { sender, recipient, contentDescription, contentReference, docOrPackage, items } = formData;

    if (step === 0) {
      const requiredSenderFields = ['name', 'country', 'address1', 'city', 'postalCode', 'email', 'phoneCode', 'phone', 'tckn'];
      requiredSenderFields.forEach(field => {
        if (!sender[field]) newErrors[`sender_${field}`] = 'Bu alan zorunludur';
      });
    }

    if (step === 1) {
      const requiredRecipientFields = ['name', 'country', 'address1', 'city', 'postalCode', 'email', 'phoneCode', 'phone', 'tckn'];
      requiredRecipientFields.forEach(field => {
        if (!recipient[field]) newErrors[`recipient_${field}`] = 'Bu alan zorunludur';
      });
    }

    if (step === 3) {
      if (!contentDescription) newErrors.contentDescription = 'Gönderi açıklaması zorunludur';
      if (!contentReference) newErrors.contentReference = 'Gönderi Referansı zorunludur';
    }

    if (step === 4) {
      if(docOrPackage === 'Paket') {
         if (!exportInvoice.number) {
            newErrors.invoice_number = 'Fatura Numarası zorunludur.';
          }
          if (!exportInvoice.signatureName) {
            newErrors.invoice_signatureName = 'İmzalayan Kişi alanı zorunludur.';
          }
          if (!exportInvoice.signatureTitle) {
            newErrors.invoice_signatureTitle = 'İmzalayan Unvanı alanı zorunludur.';
          }
      }
      if (docOrPackage === 'Paket' && items.length === 0) {
        newErrors.items = 'Lütfen en az bir öğe ekleyin.';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const downloadBase64File = (base64Data, fileName, fileType = 'application/pdf') => {
    // Base64 string'ini decode et
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });

    // İndirme linki oluştur
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Linki tıkla ve sonra kaldır
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (paymentModalOpen) {
      setPaymentToken('');
      setPaymentTokenError('');
      setPaymentTokenLoading(true);
      Services.GetTokenForPayment()
        .then((res) => {
          if (res.data.status) {
            setPaymentToken(res.data.result.token);
          } else {
            setPaymentTokenError('Ödeme için token alınamadı.');
          }
        })
        .catch(() => setPaymentTokenError('Ödeme için token alınamadı.'))
        .finally(() => setPaymentTokenLoading(false));
    }
  }, [paymentModalOpen]);

  useEffect(() => {
    if (conversationID && paymentToken) {
      const priceInTRY = selectedServiceObj?.totalPrice?.find(p => p.priceCurrency === 'TRY')?.price || 0;

      Services.PaymentWith3D(
        paymentToken,
        conversationID,
        priceInTRY,
        formData.sender.name.split(' ')[0], // Ad
        formData.sender.name.split(' ').slice(1).join(' '), // Soyad
        formData.sender.phone,
        cardName,
        cardNumber.replace(/\s/g, ''), // Boşlukları temizle
        expiredDate.slice(3, 5), // YY
        expiredDate.slice(0, 2), // AA
        cvv
      ).then((res) => {
        if (res.data.status) {
          const htmlContent = res.data.result;
          const blob = new Blob([htmlContent], { type: 'text/html' });
          const url = URL.createObjectURL(blob);
          setIframeSrc(url);
        } else {
          setIframeSrc(null);
        }
      }).catch(() => {
        setIframeSrc(null);
        setErrorMessage('3D Secure başlatılırken bir hata oluştu.');
        setShowErrorModal(true);
      });
    }
    if (!paymentModalOpen) {
      setIframeSrc(null);
      setConversationID("");
    }
  }, [conversationID, paymentToken, paymentModalOpen]);


  useEffect(() => {
    if (iframeSrc && paymentToken && conversationID) {
      intervalRef.current = setInterval(() => {
        Services.ListenPayment(paymentToken, conversationID)
          .then(async (res) => {
            if (res.data.status && res.data.result === "1") { // Başarılı ödeme
              clearInterval(intervalRef.current);
              setIframeSrc(null);
              setPaymentModalOpen(false);
              // ÖDEME BAŞARILI, ŞİMDİ GÖNDERİYİ OLUŞTUR
              await handleCreateDHLCargo();
            } else if (res.data.result === "2") { // Başarısız ödeme
              clearInterval(intervalRef.current);
              setIframeSrc(null);
              setErrorMessage("Ödeme başarısız. Lütfen bilgilerinizi kontrol edip tekrar deneyin.");
              setShowErrorModal(true);
              setConversationID(""); // Yeni bir deneme için ID'yi sıfırla
            }
          })
          .catch(err => {
            clearInterval(intervalRef.current);
            setErrorMessage("Ödeme durumu kontrol edilirken bir sorun oluştu.");
            setShowErrorModal(true);
          });
      }, 3000);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [iframeSrc, paymentToken, conversationID]);


  // YENİ EKLENEN HELPER FONKSİYONLAR
  const handleCardNumberChange = (e) => {
    const rawValue = e.target.value.replace(/\s+/g, '');
    const numbersOnly = rawValue.replace(/[^0-9]/g, '');
    const truncated = numbersOnly.slice(0, 16);
    const formatted = truncated.replace(/(\d{4})/g, '$1 ').trim();
    setCardNumber(formatted);
  };

  const handleExpiryDateChange = (e) => {
    const rawValue = e.target.value.replace(/\s*\/\s*/g, '/');
    const numbersOnly = rawValue.replace(/[^0-9]/g, '');
    let truncated = numbersOnly.slice(0, 4);
    if (truncated.length > 0 && parseInt(truncated[0], 10) > 1) {
      truncated = `0${truncated}`;
    }
    if (truncated.length >= 2 && parseInt(truncated.substring(0, 2), 10) > 12) {
      truncated = `12${truncated.slice(2)}`;
    }
    if (truncated.length > 2) {
      const formatted = `${truncated.slice(0, 2)}/${truncated.slice(2)}`;
      setExpiredDate(formatted);
    } else {
      setExpiredDate(truncated);
    }
  };

  const handleCvvChange = (e) => {
    const numbersOnly = e.target.value.replace(/[^0-9]/g, '');
    const truncated = numbersOnly.slice(0, 3);
    setCvv(truncated);
  };

  function luhnCheck(cardNumber) {
    if (!/^\d+$/.test(cardNumber)) return false;
    let sum = 0;
    let shouldDouble = false;
    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let digit = parseInt(cardNumber.charAt(i), 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
  }

  const validatePaymentForm = () => {
    const errors = {};
    const now = new Date();
    const currentYear = now.getFullYear() % 100;
    const currentMonth = now.getMonth() + 1;

    if (!cardName.trim()) {
      errors.cardName = "Kart üzerindeki isim zorunludur.";
    }
    const cardNumberDigits = cardNumber.replace(/\s/g, '');
    if (!cardNumberDigits || cardNumberDigits.length < 13 || cardNumberDigits.length > 19) {
      errors.cardNumber = "Geçerli bir kart numarası giriniz.";
    } else if (!luhnCheck(cardNumberDigits)) {
      errors.cardNumber = "Geçersiz kart numarası.";
    }

    if (!expiredDate) {
      errors.expiredDate = "Son kullanma tarihi zorunludur.";
    } else {
      const [month, year] = expiredDate.split('/');
      if (!month || !year || month.length !== 2 || year.length !== 2) {
        errors.expiredDate = "Tarihi AA/YY formatında giriniz.";
      } else {
        const expYear = parseInt(year, 10);
        const expMonth = parseInt(month, 10);
        if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
          errors.expiredDate = "Kartınızın son kullanma tarihi geçmiş.";
        }
      }
    }
    if (!cvv || cvv.length !== 3) {
      errors.cvv = "Geçerli bir CVV giriniz.";
    }
    setPaymentFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  function generateConversationID() {
    const randomPart = Date.now().toString(36) + Math.random().toString(36).substr(2, 8).substr(0, 17);
    return (
      `DHL-${randomPart.toUpperCase()}`
    )
  }

  const handleProceedToPayment = () => {
    if (validatePaymentForm()) {
      setConversationID(generateConversationID());
    }
  };

  // YENİ FONKSİYON: Ödeme sürecini başlatan fonksiyon
  const initiatePaymentProcess = () => {
    const lastStep = formData.docOrPackage === 'Paket' ? 4 : 3;
    if (validateStep(lastStep)) {
      setPaymentModalOpen(true);
    }
  };

  // DHL Gönderisi oluşturma fonksiyonu
  const handleCreateDHLCargo = async () => {

    if (!validateStep(0) || !validateStep(1) || !validateStep(3) || !validateStep(4)) {
      return;
    }

    setIsLoading(true);

    // Ülke kodu fonksiyonu
    const getCountryCode = (countryName) => {
      if (!countryName) return '';
      const lower = countryName.toLowerCase();
      if (lower.includes('germany')) return 'DE';
      if (lower.includes('turkey')) return 'TR';
      if (lower.includes('usa') || lower.includes('america')) return 'US';
      return '';
    };

    // Ortak zorunlu alanlar
    const baseData = {
      senderNameLastname: formData.sender.name,
      senderPhoneCountryCode: formData.sender.phoneCode,
      senderPhone: formData.sender.phone,
      senderCompany: formData.sender.company || '',
      senderAddress: formData.sender.address1,
      senderPostalCode: formData.sender.postalCode,
      senderCity: formData.sender.city,
      receiverCountryCode: getCountryCode(formData.recipient.country),
      receiverPhoneCountryCode: formData.recipient.phoneCode,
      receiverPhone: formData.recipient.phone,
      receiverNameLastname: formData.recipient.name,
      receiverCompany: formData.recipient.company || '',
      receiverEmail: formData.recipient.email || '',
      receiverAddress: formData.recipient.address1,
      receiverPostalCode: formData.recipient.postalCode,
      receiverCity: formData.recipient.city,
      declaredValue: parseFloat(String(formData.quoteShipmentValue).replace(',', '.')),
      declaredValueCurrency: formData.quoteCurrency,
    };

    let requestBody = {};

    // Seçilen servisin EUR fiyatını al
    const selectedPrice = selectedServiceObj?.totalPrice?.find(p => p.priceCurrency === 'EUR')?.price || 0;

    if (formData.docOrPackage === 'Döküman') {
      requestBody = {
        ...baseData,
        weight: parseFloat(String(formData.weight).replace(',', '.')),
        length: parseFloat(String(formData.length).replace(',', '.')),
        width: parseFloat(String(formData.width).replace(',', '.')),
        height: parseFloat(String(formData.height).replace(',', '.')),
        isDocument: true,
        paidPrice: selectedPrice,
        paidPriceCurrency: 'EUR',
        documentType: formData.documentType,
      };
    } else {
      // Paket için
      requestBody = {
        ...baseData,
        isCustomsDeclarable: true,
        labelDescription: formData.contentDescription || '',
        isDocument: false,
        paidPrice: selectedPrice,
        paidPriceCurrency: 'EUR',
        exportReason: formData.exportReason,
        exportInvoice: {
          date: new Date().toISOString().slice(0, 10), // İşlemin yapıldığı anki tarihi ekler
          number: formData.exportInvoice.number || '',
          signatureName: formData.exportInvoice.signatureName || '',
          signatureTitle: formData.exportInvoice.signatureTitle || ''
        },
        items: formData.items.length > 0 ? formData.items.map(item => ({
          customs: {
            quantity: Number(item.quantity) || 1,
            price: Number(item.unitValue) || 0,
            description: item.description || '',
          },
          weight: Number(item.netWeight) || 1,
          length: Number(formData.length) || 1,
          width: Number(formData.width) || 1,
          height: Number(formData.height) || 1,
          manufacturerCountry: getCountryCode(item.originCountry) || 'TR',
        })) : [
          {
            customs: {
              quantity: 1,
              price: Number(formData.quoteShipmentValue) || 0,
              description: formData.contentDescription || 'Product description'
            },
            weight: parseFloat(String(formData.weight).replace(',', '.')) || 1,
            length: parseFloat(String(formData.length).replace(',', '.')) || 1,
            width: parseFloat(String(formData.width).replace(',', '.')) || 1,
            height: parseFloat(String(formData.height).replace(',', '.')) || 1,
            manufacturerCountry: 'TR',
          }
        ],
      };
    }

    console.log("Request Body : ", requestBody);

    try {
      const response = await Services.CreateDHLCargo(requestBody);
      if (response.data && response.data.status) {
        setShipmentResponse(response.data.result);
        setCreationDate(new Date());
        setShowSummary(true); // Gönderi özeti ekranına yönlendir
      } else {
        alert('Gönderi oluşturulamadı. Lütfen bilgileri kontrol edin.');
      }
    } catch (error) {
      alert('Bir hata oluştu: ' + (error?.response?.data?.message || error.message));
    } finally {
      setIsLoading(false);
    }
  };

  // Sıfırlama fonksiyonu
  const handleResetAll = () => {
    setFormData({
      sender: {
        name: 'Ahmet Yılmaz',
        company: 'Yılmaz Lojistik',
        country: 'Turkey',
        address1: 'İkitelli OSB Mah. 10. Cad. No:12',
        address2: '',
        address3: '',
        city: 'İstanbul',
        postalCode: '34306',
        email: 'ahmet.yilmaz@example.com',
        phoneCode: '+90',
        phone: '5551234567',
        tckn: '12345678901',
        saveInfo: false,
      },
      recipient: {
        name: 'Hans Müller',
        company: 'Müller GmbH',
        country: 'Germany',
        address1: 'Hauptstrasse 5',
        address2: '',
        address3: '',
        city: 'Berlin',
        postalCode: '10115',
        email: 'hans.muller@example.de',
        phoneCode: '+49',
        phone: '1712345678',
        tckn: 'DE123456789',
      },
      shipmentType: { name: '', price: '' },
      content: '',
      customsInfo: '',
      docOrPackage: 'Paket',
      extraProtection: 'Evet',
      items: [],
      isPerformaNeed: false,
      weight: '2.5',
      weightUnit: 'KG',
      length: '30',
      width: '20',
      height: '10',
      contentReference: '',
      contentDescription: '',
      otherComments: '',
      quoteReceiverCountry: 'Germany',
      quoteReceiverCity: 'Berlin',
      quoteReceiverPostalCode: '10115',
      quoteShipmentDate: new Date().toISOString().slice(0, 10),
      quoteShipmentValue: '50',
      quoteCurrency: 'EUR',
      quoteInsuredValue: '50',
      exportReason: 'GIFT',
      exportInvoice: {
        date: new Date().toISOString().slice(0, 10),
        number: '',
        signatureName: '',
        signatureTitle: ''
      }
    });
    setItemForm({ packageType: '', description: '', quantity: '', netWeight: '', unitValue: '', originCountry: '' });
    setActiveStep(0);
    setActiveTab(0);
    setFiyatSorgulandi(false);
    setShowSummary(false);
    setShowBildirSection(false);
    setSelectedService(null);
    setIsKabulEdildi(false);
    setKabulTarihi(null);
  };

  const handleBackFromSummary = () => {
    setShowSummary(false);
    if (formData.docOrPackage === 'Paket') {
      setActiveStep(4); // Gümrük Bilgileri adımı
    } else {
      setActiveStep(2); // Gönderi Türü adımı
    }
  };

  const printDocuments = () => {
    console.log("Documents Printed")
  }
  const handlePrintDocuments = () => {
    if (!isKabulEdildi) {
      setShowNotAcceptedModal(true);
    } else {
      printDocuments();
    }
  }
  const downloadReceipt = () => {
    const receiptDoc = shipmentResponse?.documents?.find(doc => doc.typeCode === 'label');
    if (receiptDoc && receiptDoc.content) {
      console.log("Gönderi makbuzu indiriliyor...");
      downloadBase64File(receiptDoc.content, 'gonderi_makbuzu.pdf');
    } else {
      alert("İndirilecek gönderi makbuzu bulunamadı.");
    }
  }

  const downloadInvoice = () => {
    const invoiceDoc = shipmentResponse?.documents?.[1];
    if (invoiceDoc && invoiceDoc.content) {
      console.log("Fatura indiriliyor...");
      downloadBase64File(invoiceDoc.content, 'fatura.pdf');
    } else {
      alert("İndirilecek fatura bulunamadı.");
    }
  }



  // Fiyat Sorgula butonuna tıklanınca
  const handleFiyatSorgula = async () => {
    try {
      const getCountryCode = (countryName) => {
        if (!countryName) return '';
        const lowerCaseCountry = countryName.toLowerCase();
        if (lowerCaseCountry.includes('germany')) return 'DE';
        if (lowerCaseCountry.includes('turkey')) return 'TR';
        if (lowerCaseCountry.includes('usa') || lowerCaseCountry.includes('america')) return 'US';
        // Add more mappings if needed
        return '';
      };
      // API'ye gönderilecek request body'sini hazırla
      const requestData = {
        // Mock request body - bunu formdaki verilerle dolduracağız
        senderAddress: 'İkitelli OSB Mah. 10. Cad. No:12',
        senderPostalCode: '34306',
        senderCity: 'İstanbul',
        receiverAddress: formData.quoteReceiverCity,
        receiverPostalCode: formData.quoteReceiverPostalCode,
        receiverCity: formData.quoteReceiverCity,
        receiverCountryCode: getCountryCode(formData.quoteReceiverCountry),
        declaredValue: parseFloat(String(formData.quoteShipmentValue).replace(',', '.')),
        declaredValueCurrency: formData.quoteCurrency,
        weight: parseFloat(String(formData.weight).replace(',', '.')),
        length: parseFloat(String(formData.length).replace(',', '.')),
        width: parseFloat(String(formData.width).replace(',', '.')),
        height: parseFloat(String(formData.height).replace(',', '.')),
        withInsurance: formData.extraProtection === 'Evet',
        isDocument: formData.docOrPackage === 'Döküman',
      };

      console.log("Request Data : ", requestData)

      const response = await Services.GetDHLCargoRates(requestData);
      if (response.data.status && response.data.result) {
        const products = response.data.result.products || [];
        setApiProducts(products);
        setExchangeRates(response.data.result.exchangeRates);

        // Otomatik olarak ilk gönderi tipini seç
        if (products.length > 0) {
          const firstProduct = products[0];
          setSelectedService(firstProduct.productName);
          setFormData(prev => ({
            ...prev,
            shipmentType: { name: firstProduct.productName, price: firstProduct.totalPrice[0].price }
          }));
        } else {
          setSelectedService(null);
        }

        setActiveTab(1);
        setActiveStep(isFirstTimeUser ? 0 : 1);
        setFiyatSorgulandi(true);
      } else {
        // Hata durumunu yönet
        console.error("Fiyat alınamadı:", response.data);
        setApiProducts([]);
        setSelectedService(null);
      }
    } catch (error) {
      console.error('Fiyat sorgulama hatası:', error);
      setApiProducts([]);
      setSelectedService(null);
    }
  };

  const steps = getSteps(formData.docOrPackage);
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Stack spacing={2}>
            <TextField label="Ad Soyad" fullWidth value={formData.sender.name} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, name: e.target.value } }))} error={!!errors.sender_name} helperText={errors.sender_name} />
            <TextField label="Firma İsmi" fullWidth value={formData.sender.company} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, company: e.target.value } }))} />
            <TextField label="Ülkesine" InputLabelProps={{ shrink: true }} placeholder='Seçiniz' fullWidth select SelectProps={{ native: true }} value={formData.sender.country} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, country: e.target.value } }))} error={!!errors.sender_country} helperText={errors.sender_country}>
              <option value="Turkey">Turkey (TR)</option>
              <option value="Germany">Germany (DE)</option>
              <option value="USA">USA (US)</option>
            </TextField>
            <TextField label="Adres Satırı 1" fullWidth value={formData.sender.address1} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, address1: e.target.value } }))} error={!!errors.sender_address1} helperText={errors.sender_address1} />
            <TextField label="Adres Satırı 2" fullWidth value={formData.sender.address2} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, address2: e.target.value } }))} />
            <TextField label="Adres Satırı 3" fullWidth value={formData.sender.address3} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, address3: e.target.value } }))} />
            <TextField label="Şehir" fullWidth value={formData.sender.city} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, city: e.target.value } }))} error={!!errors.sender_city} helperText={errors.sender_city} />
            <TextField label="Posta Kodu" fullWidth value={formData.sender.postalCode} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, postalCode: e.target.value } }))} error={!!errors.sender_postalCode} helperText={errors.sender_postalCode} />
            <TextField label="E-Mail Adresi" fullWidth value={formData.sender.email} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, email: e.target.value } }))} error={!!errors.sender_email} helperText={errors.sender_email} />
            <Stack direction="row" spacing={2}>
              <TextField label="Alan Kodu" InputLabelProps={{ shrink: true }} placeholder='Seçiniz' fullWidth select SelectProps={{ native: true }} value={formData.sender.phoneCode} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, phoneCode: e.target.value } }))} error={!!errors.sender_phoneCode} helperText={errors.sender_phoneCode}>
                <option value="+90">+90</option>
                <option value="+49">+49</option>
                <option value="+1">+1</option>
              </TextField>
              <TextField label="Cep Telefonu" fullWidth value={formData.sender.phone} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, phone: e.target.value } }))} error={!!errors.sender_phone} helperText={errors.sender_phone} />
            </Stack>
            <TextField label="Gönderici TCKN/VKN*" fullWidth value={formData.sender.tckn} onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, tckn: e.target.value } }))} error={!!errors.sender_tckn} helperText={errors.sender_tckn} />
            <Stack direction="row" alignItems="center" spacing={1}>
              <input
                type="checkbox"
                checked={formData.sender.saveInfo}
                onChange={e => setFormData(prev => ({ ...prev, sender: { ...prev.sender, saveInfo: e.target.checked } }))}
                style={{ accentColor: '#DA3831' }}
              />
              <Typography>Müşteri bilgilerini kaydet</Typography>
            </Stack>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button sx={{ width: "100%", maxWidth: 235 }} variant="contained" color="error" size="large" onClick={() => { if (validateStep(0)) { setActiveStep(1) } }}>
                Sonraki
              </Button>
            </Box>
          </Stack>
        );
      case 1:
        return (
          <Stack spacing={2}>
            <TextField label="Ad Soyad" fullWidth value={formData.recipient.name} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, name: e.target.value } }))} error={!!errors.recipient_name} helperText={errors.recipient_name} />
            <TextField label="Firma İsmi" fullWidth value={formData.recipient.company} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, company: e.target.value } }))} />
            <TextField label="Ülkesine" placeholder='Seçiniz' InputLabelProps={{ shrink: true }} fullWidth select SelectProps={{ native: true }} value={formData.recipient.country} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, country: e.target.value } }))} error={!!errors.recipient_country} helperText={errors.recipient_country}>
              <option value="Turkey (TR)">Turkey (TR)</option>
              <option value="Germany (DE)">Germany (DE)</option>
              <option value="USA (US)">USA (US)</option>
            </TextField>
            <TextField label="Adres Satırı 1" fullWidth value={formData.recipient.address1} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, address1: e.target.value } }))} error={!!errors.recipient_address1} helperText={errors.recipient_address1} />
            <TextField label="Adres Satırı 2" fullWidth value={formData.recipient.address2} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, address2: e.target.value } }))} />
            <TextField label="Adres Satırı 3" fullWidth value={formData.recipient.address3} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, address3: e.target.value } }))} />
            <TextField label="Şehir" fullWidth value={formData.recipient.city} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, city: e.target.value } }))} error={!!errors.recipient_city} helperText={errors.recipient_city} />
            <TextField label="Posta Kodu" fullWidth value={formData.recipient.postalCode} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, postalCode: e.target.value } }))} error={!!errors.recipient_postalCode} helperText={errors.recipient_postalCode} />
            <TextField label="E-Mail Adresi" fullWidth value={formData.recipient.email} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, email: e.target.value } }))} error={!!errors.recipient_email} helperText={errors.recipient_email} />
            <Stack direction="row" spacing={2}>
              <TextField label="Alan Kodu" placeholder='Seçiniz' InputLabelProps={{ shrink: true }} fullWidth select SelectProps={{ native: true }} value={formData.recipient.phoneCode} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, phoneCode: e.target.value } }))} error={!!errors.recipient_phoneCode} helperText={errors.recipient_phoneCode}>
                <option value="+90">+90</option>
                <option value="+49">+49</option>
                <option value="+1">+1</option>
              </TextField>
              <TextField label="Cep Telefonu" fullWidth value={formData.recipient.phone} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, phone: e.target.value } }))} error={!!errors.recipient_phone} helperText={errors.recipient_phone} />
            </Stack>
            <TextField label="Alıcı TCKN/VKN*" fullWidth value={formData.recipient.tckn} onChange={e => setFormData(prev => ({ ...prev, recipient: { ...prev.recipient, tckn: e.target.value } }))} error={!!errors.recipient_tckn} helperText={errors.recipient_tckn} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button sx={{ width: "100%", maxWidth: 235 }} variant="outlined" color="error" onClick={() => setActiveStep((prev) => prev - 1)}>
                Önceki
              </Button>
              <Button sx={{ width: "100%", maxWidth: 235 }} variant="contained" color="error" size="large" onClick={() => { if (validateStep(1)) { setActiveStep(2) } }}>
                Sonraki
              </Button>
            </Box>
          </Stack>
        );
      case 2:
        return (
          <Stack spacing={2}>
            {/* Gönderi Tipi Seçimi */}
            {apiProducts.map((service, idx) => {
              const selected = selectedService === service.productName;
              const priceInfo = service.totalPrice.find(p => p.priceCurrency === 'EUR');

              return (
                <Box
                  key={service.productName}
                  onClick={() => {
                    setSelectedService(service.productName);
                    setFormData(prev => ({
                      ...prev,
                      shipmentType: { name: service.productName, price: priceInfo ? `${priceInfo.priceCurrency} ${priceInfo.price}` : '' }
                    }));
                  }}
                  sx={{
                    border: '2px solid',
                    borderColor: selected ? '#e0e0e0' : '#e0e0e0',
                    borderRadius: 1,
                    p: 0,
                    mb: 2,
                    background: '#fff',
                    cursor: 'pointer',
                    boxShadow: 'none',
                    transition: 'border 0.2s, box-shadow 0.2s',
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center" px={3} pt={2} pb={selected ? 2 : 2} borderBottom={selected ? '1px solid #e0e0e0' : 'none'}>
                    <Typography fontWeight={700} fontSize={14} color="#666">{service.productName}</Typography>
                    <Typography fontWeight={700} fontSize={14} color="#666">{priceInfo ? `${priceInfo.priceCurrency} ${priceInfo.price}` : ''}</Typography>
                  </Box>
                  {selected && (
                    <Box mt={2} borderRadius={4} px={3} pb={3} pt={2}>
                      <Box display="flex" alignItems="flex-start" justifyContent="space-between">
                        <Box>
                          <Typography fontWeight="bold" fontSize={17} color="#222">{new Date(service.deliveryCapabilities.estimatedDeliveryDateAndTime).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' })},</Typography>
                          <Typography fontWeight={400} fontSize={16} color="#222">
                            {new Date(service.deliveryCapabilities.estimatedDeliveryDateAndTime).toLocaleDateString('tr-TR', { weekday: 'long' })}, <span style={{ color: '#DA3831', fontWeight: 500 }}>{service.deliveryCapabilities.deliveryTypeCode}</span>
                          </Typography>
                          <Box mt={2} ml={2}>
                            {service.detailedPriceBreakdown[0].breakdown.map(detail => (
                              <Typography key={detail.name} color="#888" fontSize={15}>{detail.name}: {detail.price}</Typography>
                            ))}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: '50%',
                            border: '6px solid #DA3831',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#fff',
                            mt: 1,
                            mr: 1,
                          }}
                        >
                          <Box sx={{ width: 10, height: 10, borderRadius: '50%', background: '#FFF' }} />
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              );
            })}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
              <Button sx={{ width: "100%", maxWidth: 235 }} variant="outlined" color="error" onClick={() => setActiveStep((prev) => prev - 1)}>
                Önceki
              </Button>
              <Button sx={{ width: "100%", maxWidth: 235 }} variant="contained" color="error" size="large" onClick={() => setActiveStep((prev) => prev + 1)}>
                Sonraki
              </Button>
            </Box>
          </Stack>
        );
      case 3:
        // Gönderi İçeriği adımı: Paket ise detaylı, Döküman ise sade form
        if (formData.docOrPackage === 'Paket') {
          return (
            <Stack spacing={2}>
              <TextField label="Gönderi Referansı" fullWidth value={formData.contentReference || ''} helperText={errors.contentReference} onChange={e => setFormData(prev => ({ ...prev, contentReference: e.target.value }))} />
              <TextField label="Gönderi Açıklaması" fullWidth value={formData.contentDescription || ''} onChange={e => setFormData(prev => ({ ...prev, contentDescription: e.target.value }))} error={!!errors.contentDescription} helperText={errors.contentDescription} />
              <TextField label="Diğer Yorumlar" fullWidth multiline minRows={3} value={formData.otherComments || ''} onChange={e => setFormData(prev => ({ ...prev, otherComments: e.target.value }))} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button sx={{ width: "100%", maxWidth: 235 }} variant="outlined" color="error" onClick={() => setActiveStep((prev) => prev - 1)}>
                  Önceki
                </Button>
                <Button sx={{ width: "100%", maxWidth: 235 }} variant="contained" color="error" size="large" onClick={() => { if (validateStep(3)) { setActiveStep(4) } }}>
                  Sonraki
                </Button>
              </Box>
            </Stack>
          );
        } else {
          const documentTypes = [
            "Annual reports",
            "Bill of lading",
            "Certificates",
            "Charts, graphs",
            "Completed Forms",
            "Contract",
            "Credit note",
            "Deeds",
            "Diplomatic mail",
            "Documents - general business",
            "Educational material - printed",
            "Examination papers",
            "Identity document",
            "Invoices - not blank",
            "Letter, correspondence",
            "Manuscripts",
            "Medical Examination Result",
            "Music - printed, manuscript",
            "Passports",
            "Personal mail",
            "Photographs - as part of business reports",
            "Plans, drawings - for architectural, industrial, engineering purposes",
            "Price lists",
            "Printed mat",
            "Standart General Business Document"
          ];

          return (
            <Stack spacing={2}>
              <TextField label="Gönderi Açıklaması" fullWidth value={formData.contentDescription || ''} onChange={e => setFormData(prev => ({ ...prev, contentDescription: e.target.value }))} error={!!errors.contentDescription} helperText={errors.contentDescription} />
              <TextField label="Gönderi Referansı" fullWidth value={formData.contentReference || ''} onChange={e => setFormData(prev => ({ ...prev, contentReference: e.target.value }))} />
              <TextField
                select
                label="Döküman Tipi"
                fullWidth
                value={formData.documentType}
                onChange={e => setFormData(prev => ({ ...prev, documentType: e.target.value }))}
                SelectProps={{ native: false }}
              >
                {documentTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button sx={{ width: "100%", maxWidth: 235 }} variant="outlined" color="error" onClick={() => setActiveStep((prev) => prev - 1)}>
                  Önceki
                </Button>
                <Button
                  sx={{ width: "100%", maxWidth: 235 }}
                  variant="contained"
                  color="error"
                  size="large"
                  onClick={initiatePaymentProcess} // Hatalı olan handleCreateDHLCargo() yerine doğrusu eklendi
                  disabled={orderLoading}
                >
                  {orderLoading ? <CircularProgress size={24} color="inherit" /> : 'Ödeme Yap ve Gönderiyi Oluştur'}
                </Button>
              </Box>
            </Stack>
          );
        }
      case 4:
        return (
          <Stack spacing={2}>
            {/* --- YENİ EKLENEN ALANLAR BAŞLANGICI --- */}
            <Typography variant="h6" fontWeight={600}>Gümrük Faturası Bilgileri</Typography>
            <Stack spacing={2}>
              <TextField
                label="İhracat Sebebi"
                fullWidth
                select
                value={formData.exportReason}
                onChange={e => setFormData(prev => ({ ...prev, exportReason: e.target.value }))}
              >
                <MenuItem value="GIFT">Hediye (GIFT)</MenuItem>
                <MenuItem value="SAMPLE">Numune (SAMPLE)</MenuItem>
                <MenuItem value="REPAIR">Tamir (REPAIR)</MenuItem>
                <MenuItem value="COMMERCIAL">Ticari (COMMERCIAL)</MenuItem>
                <MenuItem value="RETURNED_GOODS">İade Ürün (RETURNED GOODS)</MenuItem>
              </TextField>

              <TextField
                label="Tarih"
                type="date"
                fullWidth
                disabled // Bu alanın değiştirilemez olması istendi
                value={formData.exportInvoice.date}
                InputLabelProps={{ shrink: true }}
              />

              <TextField
                label="Fatura No"
                fullWidth
                value={formData.exportInvoice.number}
                onChange={e => setFormData(prev => ({ ...prev, exportInvoice: { ...prev.exportInvoice, number: e.target.value } }))}
              />

              <TextField
                label="İmzalayan Kişi (Signature Name)"
                fullWidth
                value={formData.exportInvoice.signatureName}
                onChange={e => setFormData(prev => ({ ...prev, exportInvoice: { ...prev.exportInvoice, signatureName: e.target.value } }))}
              />

              <TextField
                label="İmzalayan Unvanı (Signature Title)"
                fullWidth
                value={formData.exportInvoice.signatureTitle}
                onChange={e => setFormData(prev => ({ ...prev, exportInvoice: { ...prev.exportInvoice, signatureTitle: e.target.value } }))}
              />
            </Stack>

            <Box my={2}><hr /></Box>
            {/* --- YENİ EKLENEN ALANLAR SONU --- */}
            <Typography variant="h6" fontWeight={600}>Öğe 1</Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField label="Paket Türü" fullWidth value={itemForm.packageType} onChange={e => setItemForm(f => ({ ...f, packageType: e.target.value }))} />
              <Button variant="contained" color="error" sx={{ minWidth: 180 }} onClick={() => setShowDescModal(true)}>Tanım Oluştur</Button>
              <Button variant="outlined" color="error" sx={{ minWidth: 80 }} onClick={() => setItemForm({ packageType: '', description: '', quantity: '', netWeight: '', unitValue: '', originCountry: '' })}>Sil</Button>
            </Stack>
            <TextField
              label="Tanım"
              fullWidth
              multiline
              minRows={3}
              value={itemForm.description}
              onChange={e => setItemForm(f => ({ ...f, description: e.target.value }))}
              onFocus={e => {
                if ((itemForm.description || '').length <= 5) {
                  setDescTooltipAnchor(e.currentTarget);
                }
              }}
            />

            <Stack sx={{ display: 'flex', alignItems: 'center', position: 'relative', width: 'fit-content' }}>
              <Popover
                open={Boolean(descTooltipAnchor) && (itemForm.description || '').length <= 5}
                anchorEl={descTooltipAnchor}
                onClose={() => setDescTooltipAnchor(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                PaperProps={{ sx: { p: 2, maxWidth: 596, position: 'relative', pb: 3, overflow: 'visible' } }}
                disableRestoreFocus
                disableEnforceFocus
                disableAutoFocus
              >
                <Typography sx={{ fontSize: 15, fontWeight: 500, mb: 1 }}>Tek kelime ya da daha az karakterli tanımlamalarından Kaçının. Yazın, aşağıdaki soruları cevaplayın:</Typography>
                <Typography sx={{ fontSize: 14, mb: 0.5 }}><span style={{ fontWeight: 'bold' }}>Ürün nedir?</span> (Örnek: Marka/ Üretici/Model/Part Numarası)</Typography>
                <Typography sx={{ fontSize: 14, mb: 0.5 }}><span style={{ fontWeight: 'bold' }}>Neyden yapılmıştır/üretilmiştir?</span> (örnek: Wood/Plastic/Aluminium)</Typography>
                <Typography sx={{ fontSize: 14, mb: 0.5 }}><span style={{ fontWeight: 'bold' }}>Ne için kullanılacak?</span> (örnek: tanım/kullanım amacı)</Typography>
                <Typography onClick={() => setShowDescModal(true)} sx={{ fontSize: 14, mt: 1, cursor: 'pointer' }}><span style={{ fontWeight: 'bold' }}>Tanım Oluştur</span> butonunu kullanarak tanım oluşturabilirsiniz.</Typography>
                <Box sx={{
                  position: 'absolute',
                  left: '0',
                  bottom: -14,
                  width: 0,
                  height: 0,
                  borderLeft: '12px solid transparent',
                  borderRight: '12px solid transparent',
                  borderTop: '16px solid #fff',
                  filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.08))',
                  zIndex: 10
                }} />
              </Popover>
            </Stack>
            <Dialog open={showDescModal} onClose={() => setShowDescModal(false)} maxWidth="sm" fullWidth>
              <DialogTitle>Ürünlerinizi tanımlayın</DialogTitle>
              <DialogContent>
                <Typography sx={{ mb: 2 }}>Ürünlerinizi detaylı olarak açıkladığınızdan emin olun. Doğru tanımlamalar, gönderinin uygunluğunu değerlendirmek için kullanılır ve gönderinizin sorunsuz şekilde hareket etmesine yardım eder.</Typography>
                <Stack spacing={2}>
                  <TextField label="Ürün nedir?" placeholder="Örnek: Shoes or toys" fullWidth value={descModalFields.product} onChange={e => setDescModalFields(f => ({ ...f, product: e.target.value }))} />
                  <TextField label="Ürün ya da Marka" placeholder="Ürünü üreten marka ya da üretici kimdir?" fullWidth value={descModalFields.brand} onChange={e => setDescModalFields(f => ({ ...f, brand: e.target.value }))} />
                  <TextField label="Modeli, stili ya da türü nedir?" placeholder="Örnek: M5797U" fullWidth value={descModalFields.model} onChange={e => setDescModalFields(f => ({ ...f, model: e.target.value }))} />
                  <TextField label="Neyden yapılmıştır?" placeholder="Örnek: Plastic, aluminum, wood" fullWidth value={descModalFields.material} onChange={e => setDescModalFields(f => ({ ...f, material: e.target.value }))} />
                  <TextField label="Nasıl kullanılacak?" placeholder="Örnek: Athletic activity or children's play" fullWidth value={descModalFields.usage} onChange={e => setDescModalFields(f => ({ ...f, usage: e.target.value }))} />
                  <TextField label="Ürün açıklaması" placeholder="Ürün açıklaması" fullWidth value={descModalFields.description} onChange={e => setDescModalFields(f => ({ ...f, description: e.target.value }))} />
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" color="error" onClick={() => {
                  const allDesc = [descModalFields.product, descModalFields.brand, descModalFields.model, descModalFields.material, descModalFields.usage, descModalFields.description].filter(Boolean).join(' - ');
                  setItemForm(f => ({ ...f, description: allDesc }));
                  setShowDescModal(false);
                }}>Tamam</Button>
              </DialogActions>
            </Dialog>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField label="Adet *" fullWidth value={itemForm.quantity} onChange={e => setItemForm(f => ({ ...f, quantity: e.target.value }))} />
              <TextField label="Net Ağırlık * (KG)" fullWidth value={itemForm.netWeight} onChange={e => setItemForm(f => ({ ...f, netWeight: e.target.value }))} />
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField label="Birim Değeri* (TRY)" fullWidth value={itemForm.unitValue} onChange={e => setItemForm(f => ({ ...f, unitValue: e.target.value }))} />
              <TextField label="Menşei Ülke (Üretim Ülkesi)" fullWidth value={itemForm.originCountry} onChange={e => setItemForm(f => ({ ...f, originCountry: e.target.value }))} />
            </Stack>
            {/* Eklenen öğeler listesi */}
            {formData.items.length > 0 && (
              <Box mt={3}>
                {formData.items.map((item, idx) => (
                  <Paper key={idx} sx={{ p: 2, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography fontWeight={600}>Öğe {idx + 1}</Typography>
                      <Typography>Paket Türü: {item.packageType}</Typography>
                      <Typography>Tanım: {item.description}</Typography>
                      <Typography>Adet: {item.quantity} | Net Ağırlık: {item.netWeight} kg</Typography>
                      <Typography>Birim Değeri: {item.unitValue} | Menşei Ülke: {item.originCountry}</Typography>
                    </Box>
                    <Button variant="outlined" color="error" onClick={() => setFormData(prev => ({ ...prev, items: prev.items.filter((_, i) => i !== idx) }))}>Sil</Button>
                  </Paper>
                ))}
              </Box>
            )}
            {errors.items && <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>{errors.items}</Typography>}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button variant="outlined" color="error" onClick={() => {
                // Tüm alanlar doluysa ekle
                if (itemForm.packageType && itemForm.description && itemForm.quantity && itemForm.netWeight && itemForm.unitValue && itemForm.originCountry) {
                  setFormData(prev => ({ ...prev, items: [...prev.items, itemForm] }));
                  setItemForm({ packageType: '', description: '', quantity: '', netWeight: '', unitValue: '', originCountry: '' });
                }
              }} sx={{ width: '100%', maxWidth: 235 }}>Öge Ekle</Button>
              <Button
                variant="contained"
                color="error"
                size="large"
                onClick={initiatePaymentProcess} // DEĞİŞTİ
                sx={{ width: '100%', maxWidth: 235 }}
                disabled={orderLoading}
              >
                {orderLoading ? <CircularProgress size={24} color="inherit" /> : 'Ödeme Yap ve Gönderiyi Oluştur'}
              </Button>
            </Box>
          </Stack>
        );
      default:
        return null;
    }
  };

  // Sağ panelde seçili gönderi tipinin tüm detaylarını bul
  const selectedServiceObj = apiProducts.find(s => s.productName === selectedService) || (apiProducts.length > 0 ? apiProducts[0] : null);


  // Gönderi Özeti Section
  if (showBildirSection) {
    // PLT bölgesi kontrolü örneği (örnek: ülke adı "PLT" ise)
    const isPLT = formData.recipient.country === 'PLT';
    return (
      <Box sx={{ backgroundColor: "#FFF", width: '100%', height: '100%', paddingInline: '5%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', pt: 6 }}>
        <Stack sx={{ width: '100%', maxWidth: 680, mb: 4, borderRadius: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4, borderBottom: '1px solid #ECE8E8', width: '100%', pb: 1, }}>
            <Typography variant="p" sx={{ pb: 1, color: '#515151', fontSize: "16px", fontWeight: 600 }}>Gönderi Özeti</Typography>
            <Button sx={{ border: '1px solid #D0CECE', color: '#B5B5B5', borderRadius: .5 }} onClick={() => setShowSupportModal(true)}>Destek Talebi Oluştur</Button>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
            <Box>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Waybill (Konşimento) numarası</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 2 }}>{shipmentResponse?.shipmentTrackingNumber || 'Yükleniyor...'}</Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Referans Numarası</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 2 }}>{shipmentResponse?.packages?.[0]?.trackingNumber || 'Yükleniyor...'}</Typography>
            </Box>
            <Box>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Oluşturma Tarihi</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 2 }}>
                {creationDate ? creationDate.toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}
              </Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Genel Toplam</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, color: '#DA3831' }}>{selectedServiceObj.totalPrice[0].priceCurrency} {selectedServiceObj.totalPrice[0].price}</Typography>
            </Box>
          </Box>
          {/* PLT bölgesi değilse ve ülke noNeedPLTCountries'de yoksa göster */}
          {!isPLT && !noNeedPLTCountries.includes(formData.recipient.country) && (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", mb: 2 }}>
              <Typography sx={{ fontWeight: 600, mr: 2 }}>PLT bölgesi değildir</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  checked={formData.isPerformaNeed}
                  onChange={e => setFormData(prev => ({ ...prev, isPerformaNeed: e.target.checked }))}
                  style={{ accentColor: '#DA3831', marginRight: 6 }}
                />
                <Typography sx={{ fontSize: 14, mr: 1 }}>Proforma faturayı eklediniz mi?</Typography>
              </Box>
            </Box>
          )}
          <Box sx={{ display: 'flex', gap: 6, mt: 4, mb: 2 }}>
            <Box sx={{ flex: 1, display: "flex", flexDirection: 'column' }}>
              <Box sx={{ display: "flex" }}>
                <Box>
                  <Typography fontWeight={700} sx={{ mb: 1 }}>ADIM 1</Typography>
                  <Typography sx={{ mb: 2 }}>Gönderiyi Kabul Et'e tıklayın ve alıcıya makbuz gönderin</Typography>
                </Box>
                <img src="/assets/icons/cargo-step-one.png" alt="step one" width={93} height={73} style={{ marginBottom: 8 }} />
              </Box>
              {!isKabulEdildi ? (
                <Button
                  variant="contained"
                  color="error"
                  sx={{ width: '100%', maxWidth: 235, mt: 'auto', height: 48, backgroundColor: '#DA3831', fontWeight: 600, fontSize: 16 }}
                  onClick={() => {
                    setIsKabulEdildi(true);
                    setShowKabulModal(true);
                    setKabulTarihi(new Date());
                  }}
                >
                  Gönderiyi Kabul Et
                </Button>
              ) : (
                <Button
                  variant="contained"
                  disabled
                  sx={{
                    width: '100%',
                    maxWidth: 277,
                    mt: 'auto',
                    height: 77,
                    backgroundColor: '#F4F4F4',
                    color: '#B5B5B5',
                    fontWeight: 500,
                    fontSize: 16,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'none',
                    cursor: 'default',
                    textTransform: 'none',
                    p: 0,
                  }}
                >
                  <span style={{ fontSize: 16, color: '#B5B5B5', fontWeight: 500, lineHeight: 1 }}>Gönderi Kabul Edilme Zamanı</span>
                  <span style={{ fontSize: 16, color: '#B5B5B5', fontWeight: 500, lineHeight: 1 }}>
                    {kabulTarihi ? `${kabulTarihi.toLocaleDateString('tr-TR')} - ${kabulTarihi.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}` : '-'}
                  </span>
                </Button>
              )}
            </Box>
            <Box sx={{ flex: 1, display: "flex", flexDirection: 'column' }}>
              <Box sx={{ display: "flex" }}>
                <Box>
                  <Typography fontWeight={700} sx={{ mb: 1 }}>ADIM 2</Typography>
                  <Typography sx={{ mb: 2 }}>Gönderi belgelerini yazdırın ve gönderi ile birlikte DHL kuryesine teslim edin</Typography>
                </Box>
                <img src="/assets/icons/cargo-step-one-v2.png" alt="step one" width={93} height={73} style={{ marginBottom: 8 }} />
              </Box>
              <Button onClick={handlePrintDocuments} variant="outlined" color="error" sx={{ width: '100%', maxWidth: "235", mt: 3, height: 48, color: '#DA3831' }}>Gerekli Belgeleri Yazdır</Button>
            </Box>
          </Box>
          <Stack sx={{ display: 'flex', flexDirection: "column", gap: 1 }}>
            <Box
              sx={{
                width: "fit-content",
                marginLeft: "auto",
                color: '#515151',
                borderBottom: "1px solid #515151",
                fontSize: "14px",
                textAlign: "right",
                alignItems: "flex-end",
                cursor: isKabulEdildi ? 'pointer' : 'default',
                pointerEvents: isKabulEdildi ? 'auto' : 'none',
                opacity: isKabulEdildi ? 1 : 0.5,
              }}
              onClick={isKabulEdildi ? () => downloadReceipt() : undefined}
            >Gönderi Makbuzunu İndir</Box>
            <Box
              sx={{
                width: "fit-content",
                marginLeft: "auto",
                color: '#515151',
                borderBottom: "1px solid #515151",
                fontSize: "14px",
                textAlign: "right",
                alignItems: "flex-end",
                cursor: isKabulEdildi ? 'pointer' : 'default',
                pointerEvents: isKabulEdildi ? 'auto' : 'none',
                opacity: isKabulEdildi ? 1 : 0.5,
              }}
              onClick={isKabulEdildi ? () => downloadInvoice() : undefined}
            >Faturayı İndir</Box>
            <Box
              sx={{
                width: "fit-content",
                marginLeft: "auto",
                color: '#515151',
                borderBottom: "1px solid #515151",
                fontSize: "14px",
                textAlign: "right",
                alignItems: "flex-end",
                cursor: isKabulEdildi ? 'pointer' : 'default',
                pointerEvents: isKabulEdildi ? 'auto' : 'none',
                opacity: isKabulEdildi ? 1 : 0.5,
              }}
              onClick={isKabulEdildi ? () => setShowDetailsModal(true) : undefined}
            >Gönderi Detaylarını Görüntüle</Box>
          </Stack>
          <Stack direction="row" spacing={3} justifyContent="center" mt={5}>
            <Button variant="contained" color="error" sx={{ width: "100%", height: "48px", maxWidth: 345, fontWeight: 600, fontSize: 16, backgroundColor: '#DA3831', marginRight: "auto" }} onClick={handleResetAll}>Başka Bir Gönderi Oluştur</Button>
          </Stack>
        </Stack>
        {/* Destek Talebi Oluştur Modal */}
        <Dialog open={showSupportModal} onClose={() => setShowSupportModal(false)} maxWidth={false} PaperProps={{ sx: { maxWidth: 674, maxHeight: 500, width: '100%', borderRadius: 2 } }}>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 16 }}>DHL'YE YENİ MESAJ OLUŞTURUN</Typography>
            <IconButton onClick={() => setShowSupportModal(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Stack spacing={2}>
              <TextField label="Başlık" fullWidth value={supportTitle} onChange={e => setSupportTitle(e.target.value)} />
              <TextField label="İçerik" fullWidth multiline minRows={6} value={supportContent} onChange={e => setSupportContent(e.target.value)} />
              <Button variant="contained" color="error" sx={{ backgroundColor: '#DA3831', width: '100%', maxWidth: 235, height: 48, alignSelf: 'flex-start', mt: 2 }}>Talebi Gönder</Button>
            </Stack>
          </DialogContent>
        </Dialog>
        {/* Gönderi Kabul İşlemi Sonrası Modal */}
        <Dialog open={showKabulModal} onClose={() => setShowKabulModal(false)} maxWidth={false} PaperProps={{ sx: { maxWidth: 700, borderRadius: 2 } }}>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0 }}>
            <IconButton onClick={() => setShowKabulModal(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2, pb: 4, px: 4 }}>
            <Typography sx={{ color: '#515151', fontSize: 18, mb: 2 }}>
              Değerli İş Ortağımız,<br />
              Lütfen gönderi işlemlerini tamamlamadan önce ödemenin yapıldığından emin olunuz. Eger ödemeyi aldıysanız teşekkürler. Ödeme süreçleri konusunda sorularınız varsa ya da hesabınızla ilgili herhangi bir yardıma ihtiyacınız olursa lütfen bizimle irtibata geçiniz.
            </Typography>
            <Typography sx={{ color: '#515151', fontSize: 18, mb: 4 }}>
              Sorunsuz operasyonlar ve tüm müşterilerimiz için mükemmel hizmeti sağlamada iş birliğiniz önemlidir. İlginiz için teşekkür ederiz.
            </Typography>
            <Button variant="contained" color="error" sx={{ backgroundColor: '#DA3831', width: 200, height: 48, fontSize: 18, fontWeight: 600 }} onClick={() => setShowKabulModal(false)}>Kapat</Button>
          </DialogContent>
        </Dialog>
        {/* Gönderi Detaylarını Görüntüle Modal - Custom Accordion */}
        <Dialog open={showDetailsModal} onClose={() => setShowDetailsModal(false)} maxWidth={false} PaperProps={{ sx: { width: '100%', maxWidth: 700, borderRadius: 2 } }}>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0 }}>
            <IconButton sx={{ marginLeft: 'auto' }} onClick={() => setShowDetailsModal(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2, pb: 4, px: 2 }}>
            <Box sx={{ border: '1px solid #E5E7EB', borderRadius: 2, background: '#fff' }}>
              {/* Kimden */}
              <Box sx={{ borderBottom: '1px solid #E5E7EB', pb: 1, mb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', p: 2 }} onClick={() => setOpenAccordion(openAccordion === 'from' ? null : 'from')}>
                  <Typography sx={{ fontWeight: 700, fontSize: 18, color: openAccordion === 'from' ? '#DA3831' : '#1F2937', mr: 1 }}>
                    {openAccordion === 'from' ? '–' : '+'}
                  </Typography>
                  <Typography sx={{ fontWeight: 700, fontSize: 18, color: openAccordion === 'from' ? '#DA3831' : '#1F2937' }}>Kimden</Typography>
                </Box>
                {openAccordion === 'from' && (
                  <Box sx={{ mt: 2, ml: 4 }}>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.name}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.company}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.address1}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.city}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.country}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.postalCode}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.email}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.sender.phoneCode}{formData.sender.phone}</span></Typography>
                  </Box>
                )}
              </Box>
              {/* Kime */}
              <Box sx={{ borderBottom: '1px solid #E5E7EB', pb: 1, mb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', p: 2 }} onClick={() => setOpenAccordion(openAccordion === 'to' ? null : 'to')}>
                  <Typography sx={{ fontWeight: 700, fontSize: 18, color: openAccordion === 'to' ? '#DA3831' : '#1F2937', mr: 1 }}>
                    {openAccordion === 'to' ? '–' : '+'}
                  </Typography>
                  <Typography sx={{ fontWeight: 700, fontSize: 18, color: openAccordion === 'to' ? '#DA3831' : '#1F2937' }}>Kime</Typography>
                </Box>
                {openAccordion === 'to' && (
                  <Box sx={{ mt: 2, ml: 4 }}>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}> <span style={{ color: '#111' }}>{formData.recipient.name}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.recipient.company}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.recipient.address1}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.recipient.city}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.recipient.country}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.recipient.postalCode}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.recipient.email}</span></Typography>
                    <Typography sx={{ color: '#6B7280', fontWeight: 500 }}><span style={{ color: '#111' }}>{formData.recipient.phoneCode}{formData.recipient.phone}</span></Typography>
                  </Box>
                )}
              </Box>
              {/* Gönderi Detayları */}
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', p: 2 }} onClick={() => setOpenAccordion(openAccordion === 'details' ? null : 'details')}>
                  <Typography sx={{ fontWeight: 700, fontSize: 18, color: openAccordion === 'details' ? '#DA3831' : '#1F2937', mr: 1 }}>
                    {openAccordion === 'details' ? '–' : '+'}
                  </Typography>
                  <Typography sx={{ fontWeight: 700, fontSize: 18, color: openAccordion === 'details' ? '#DA3831' : '#1F2937' }}>Gönderi Detayları</Typography>
                </Box>
                {openAccordion === 'details' && (
                  <Box sx={{ mt: 2, ml: 4 }}>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                      <Typography sx={{ color: '#6B7280', fontWeight: 500, minWidth: 140 }}>Gönderi Türü</Typography>
                      <Typography sx={{ color: '#111', fontWeight: 500 }}>{formData.docOrPackage}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                      <Typography sx={{ color: '#6B7280', fontWeight: 500, minWidth: 140 }}>Ürün</Typography>
                      <Typography sx={{ color: '#111', fontWeight: 500 }}>{formData.items.map(item => item.description).join(' - ')}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                      <Typography sx={{ color: '#6B7280', fontWeight: 500, minWidth: 140 }}>Tarih</Typography>
                      <Typography sx={{ color: '#111', fontWeight: 500 }}>
                        {creationDate ? creationDate.toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                      <Typography sx={{ color: '#6B7280', fontWeight: 500, minWidth: 140 }}>Son Kayıt Saati</Typography>
                      <Typography sx={{ color: '#111', fontWeight: 500 }}>2025-04-25T17:30:00.000+00:00</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                      <Typography sx={{ color: '#6B7280', fontWeight: 500, minWidth: 140 }}>Ürün Türü</Typography>
                      <Typography sx={{ color: '#111', fontWeight: 500 }}>{formData.contentDescription}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                      <Typography sx={{ color: '#6B7280', fontWeight: 500, minWidth: 140 }}>Toplam Tutar</Typography>
                      <Typography sx={{ color: '#DA3831', fontWeight: 600, textDecoration: 'underline' }}>{selectedServiceObj.totalPrice[0].priceCurrency} {selectedServiceObj.totalPrice[0].price}</Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        {/* Gönderi Kabul Edilmedi Modal */}
        <Dialog open={showNotAcceptedModal} onClose={() => setShowNotAcceptedModal(false)} maxWidth={false} PaperProps={{ sx: { width: '100%', maxWidth: 600, borderRadius: 2 } }}>
          <DialogTitle sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', pb: 0 }}>
            <IconButton sx={{ marginLeft: 'auto' }} onClick={() => setShowNotAcceptedModal(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2, pb: 4, px: 4, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
            <img src="/assets/icons/cargo-step-one-v2.png" alt="step one" style={{ width: 180, height: 120, marginBottom: 24, alignSelf: 'center' }} />
            <Typography sx={{ fontWeight: 700, fontSize: 18, color: '#222', mb: 2, mt: 1 }}>GÖNDERİ KABUL EDİLMEDİ</Typography>
            <Typography sx={{ color: '#515151', fontSize: 16, mb: 4, textAlign: 'left' }}>
              Lütfen belgeleri yazdırmadan önce "Gönderiyi Kabul Et" ya da "Accept Shipment" yazısına tıklayın.
            </Typography>
            <Button variant="contained" color="error" sx={{ backgroundColor: '#DA3831', width: 200, height: 48, fontSize: 18, fontWeight: 600 }} onClick={() => setShowNotAcceptedModal(false)}>Tamam</Button>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  if (showSummary) {
    return (
      <Box sx={{ backgroundColor: "#FFF", width: '100%', height: '100%', paddingInline: '5%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', pt: 6 }}>

        <Stack sx={{ width: '100%', maxWidth: 680, mb: 4, borderRadius: 3 }}>
          <Typography variant="p" sx={{ pb: 1, mb: 6, color: '#515151', fontSize: "16px", fontWeight: 600, borderBottom: '1px solid #ECE8E8' }}>Gönderi Özeti</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
            <Box>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Gönderi Türü</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 2 }}>{formData.docOrPackage}</Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Tarih</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 2 }}>{creationDate ? creationDate.toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '-'}</Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Detay</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16 }}>{formData.contentDescription || '-'}</Typography>
            </Box>
            <Box>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Ürün</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 2 }}>{formData.items.map(item => item.description).join(' - ')}</Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Son Kayıt Saati</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 2 }}>{creationDate ? creationDate.toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-'}</Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Toplam Tutar</Typography>
              <Typography sx={{ fontWeight: 600, fontSize: 16, color: '#DA3831' }}>{selectedServiceObj && selectedServiceObj.totalPrice ? `${selectedServiceObj.totalPrice[0].price} ${selectedServiceObj.totalPrice[0].priceCurrency}` : '-'}</Typography>
            </Box>
          </Box>
          <Box sx={{ borderTop: '1px solid #ECE8E8', pt: 4, display: 'flex', justifyContent: 'space-between', gap: 6 }}>
            <Box>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Alıcı</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.recipient.name}</Typography>
              <Typography>{formData.recipient.address1}</Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15, mt: 2 }}>Alıcı Adres</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.recipient.city}</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.recipient.country}</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.recipient.postalCode}</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.recipient.phoneCode}{formData.recipient.phone}</Typography>
            </Box>
            <Box>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15 }}>Gönderici</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.sender.name}</Typography>
              <Typography>{formData.sender.address1}</Typography>
              <Typography fontWeight={500} sx={{ color: '#515151', fontSize: 15, mt: 2 }}>Gönderici Adres</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.sender.city}</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.sender.country}</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.sender.postalCode}</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.sender.email}</Typography>
              <Typography sx={{ fontWeight: 600 }}>{formData.sender.phoneCode}{formData.sender.phone}</Typography>
            </Box>
          </Box>
          <Stack direction="row" spacing={3} justifyContent="center" mt={5}>
            <Button variant="outlined" color="error" sx={{ width: "100%", height: "48px", maxWidth: 235, fontWeight: 600, fontSize: 16 }} onClick={handleBackFromSummary}>Önceki</Button>
            <Button variant="outlined" color="error" sx={{ width: "100%", height: "48px", maxWidth: 235, fontWeight: 600, fontSize: 16 }} onClick={handleBackFromSummary}>Kayıt/Güncelle</Button>
            <Button variant="contained" color="error" sx={{ backgroundColor: "#DA3831", width: "100%", height: "48px", maxWidth: 235, fontWeight: 600, fontSize: 16 }} onClick={() => setShowBildirSection(true)}>Bildir</Button>
          </Stack>
        </Stack>
      </Box>
    );
  }

  // Ücret Detayları 
  return (
    <Box sx={{ width: '100%', height: '100%', paddingInline: "5%", display: 'flex', justifyContent: 'space-between', gap: 5 }}>
      <Box sx={{ width: '100%' }}>
        <Typography variant="p" marginBottom={5} display={"block"}>DHL Gönderisi Oluşturma</Typography>
        {!fiyatSorgulandi && (
          <Box sx={{ width: '100%', maxWidth: '680px', display: 'flex', gap: 2, mb: 0.5, mt: 2 }}>
            <Box sx={{ width: '50%', borderTop: '5px solid #DA3831', transition: 'border-color 0.2s', fontSize: '13px', paddingTop: 1 }}>Fiyat ve Tarih Sorgulama</Box>
            <Box sx={{ width: '50%', borderTop: '5px solid #ECEFF1', transition: 'border-color 0.2s', fontSize: '13px', paddingTop: 1 }}>Gönderi Oluştur</Box>
          </Box>
        )}
        {!fiyatSorgulandi && activeTab === 0 && (
          <Box sx={{ mt: 3, maxWidth: '680px', width: '100%' }}>
            <Typography variant="h6">Fiyat ve Tarih Sorgulama</Typography>
            <Stack spacing={2} mt={2}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  label="Ülkesine"
                  fullWidth
                  value={formData.quoteReceiverCountry}
                  onChange={(e) => setFormData(f => ({ ...f, quoteReceiverCountry: e.target.value }))}
                  select
                >
                  <MenuItem value="Germany">Germany (DE)</MenuItem>
                  <MenuItem value="USA">USA (US)</MenuItem>
                  <MenuItem value="Turkey">Turkey (TR)</MenuItem>
                </TextField>
                <TextField label="Şehir" fullWidth value={formData.quoteReceiverCity} onChange={(e) => setFormData(f => ({ ...f, quoteReceiverCity: e.target.value }))} />
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField label="Posta Kodu" fullWidth value={formData.quoteReceiverPostalCode} onChange={(e) => setFormData(f => ({ ...f, quoteReceiverPostalCode: e.target.value }))} />
                <TextField
                  label="Ne Zaman Gönderiyorsunuz?"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  value={formData.quoteShipmentDate}
                  onChange={(e) => setFormData(f => ({ ...f, quoteShipmentDate: e.target.value }))}
                />
              </Stack>
              <Typography sx={{ mt: 2 }}>Ne gönderiyorsunuz?</Typography>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<Icon icon="mdi:file-document-outline" width={24} height={24} color={formData.docOrPackage === 'Döküman' ? 'white' : '#DA3831'} />}
                  onClick={() => setFormData((prev) => ({ ...prev, docOrPackage: 'Döküman' }))}
                  sx={{
                    height: '44px',
                    backgroundColor: formData.docOrPackage === 'Döküman' ? '#DA3831' : 'white',
                    color: formData.docOrPackage === 'Döküman' ? 'white' : '#DA3831',
                    borderColor: '#DA3831',
                    fontWeight: formData.docOrPackage === 'Döküman' ? 'bold' : 'normal',
                    '&:hover': {
                      backgroundColor: formData.docOrPackage === 'Döküman' ? '#b71c1c' : '#f5f5f5',
                    },
                  }}
                >
                  Döküman
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<Icon icon="mdi:package-variant-closed" width={24} height={24} color={formData.docOrPackage === 'Paket' ? 'white' : '#DA3831'} />}
                  onClick={() => setFormData((prev) => ({ ...prev, docOrPackage: 'Paket' }))}
                  sx={{
                    height: '44px',
                    backgroundColor: formData.docOrPackage === 'Paket' ? '#DA3831' : 'white',
                    color: formData.docOrPackage === 'Paket' ? 'white' : '#DA3831',
                    borderColor: '#DA3831',
                    fontWeight: formData.docOrPackage === 'Paket' ? 'bold' : 'normal',
                    '&:hover': {
                      backgroundColor: formData.docOrPackage === 'Paket' ? '#b71c1c' : '#f5f5f5',
                    },
                  }}
                >
                  Paket
                </Button>
              </Stack>
              <Typography sx={{ mt: 2, fontSize: 14 }}>
                Müşteriye, gönderisine ekstra koruma isteyip istemediğini sorun (Ek ücretler olacaktır)
              </Typography>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<Icon icon="mdi:check-circle-outline" width={24} height={24} color={formData.extraProtection === 'Evet' ? 'white' : '#DA3831'} />}
                  onClick={() => setFormData((prev) => ({ ...prev, extraProtection: 'Evet' }))}
                  sx={{
                    height: '44px',
                    backgroundColor: formData.extraProtection === 'Evet' ? '#DA3831' : 'white',
                    color: formData.extraProtection === 'Evet' ? 'white' : '#DA3831',
                    borderColor: '#DA3831',
                    fontWeight: formData.extraProtection === 'Evet' ? 'bold' : 'normal',
                    '&:hover': {
                      backgroundColor: formData.extraProtection === 'Evet' ? '#b71c1c' : '#f5f5f5',
                    },
                  }}
                >
                  Evet
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<Icon icon="mdi:close-circle-outline" width={24} height={24} color={formData.extraProtection === 'Hayır' ? 'white' : '#DA3831'} />}
                  onClick={() => setFormData((prev) => ({ ...prev, extraProtection: 'Hayır' }))}
                  sx={{
                    height: '44px',
                    backgroundColor: formData.extraProtection === 'Hayır' ? '#DA3831' : 'white',
                    color: formData.extraProtection === 'Hayır' ? 'white' : '#DA3831',
                    borderColor: '#DA3831',
                    fontWeight: formData.extraProtection === 'Hayır' ? 'bold' : 'normal',
                    '&:hover': {
                      backgroundColor: formData.extraProtection === 'Hayır' ? '#b71c1c' : '#f5f5f5',
                    },
                  }}
                >
                  Hayır
                </Button>
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField label="En (cm)" fullWidth value={formData.length} onChange={e => setFormData(prev => ({ ...prev, length: e.target.value }))} />
                <TextField label="Boy (cm)" fullWidth value={formData.width} onChange={e => setFormData(prev => ({ ...prev, width: e.target.value }))} />
                <TextField label="Yükseklik (cm)" fullWidth value={formData.height} onChange={e => setFormData(prev => ({ ...prev, height: e.target.value }))} />
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 2 }}>
                <TextField
                  label="Ağırlık"
                  fullWidth
                  value={formData.weight || ''}
                  onChange={e => setFormData(prev => ({ ...prev, weight: e.target.value }))}
                />
                <TextField
                  label="Birim"
                  fullWidth
                  select
                  SelectProps={{ native: true }}
                  value={formData.weightUnit || 'KG'}
                  onChange={e => setFormData(prev => ({ ...prev, weightUnit: e.target.value }))}
                >
                  <option value="KG">KG</option>
                </TextField>
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField label="Gönderi Değeri" fullWidth value={formData.quoteShipmentValue} onChange={(e) => setFormData(f => ({ ...f, quoteShipmentValue: e.target.value }))} />
                <TextField
                  label="Para Birimi"
                  fullWidth
                  value={formData.quoteCurrency}
                  onChange={(e) => setFormData(f => ({ ...f, quoteCurrency: e.target.value }))}
                  select
                  SelectProps={{ native: true }}
                >
                  <option value="TRY">TRY</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </TextField>
                <TextField label="Sigortalanan Değer" fullWidth value={formData.quoteInsuredValue} onChange={(e) => setFormData(f => ({ ...f, quoteInsuredValue: e.target.value }))} />
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                <input
                  type="checkbox"
                  checked={isHizmetNoktasiChecked}
                  onChange={e => setIsHizmetNoktasiChecked(e.target.checked)}
                  style={{ accentColor: '#DA3831' }}
                />
                <Typography>Hizmet Noktası Kapasite</Typography>
              </Stack>
              <Button sx={{
                width: "100%",
                maxWidth: "235px",
                alignSelf: "flex-end",
                backgroundColor: "#DA3831"
              }} variant="contained" color="error" size="large" onClick={handleFiyatSorgula}>
                Fiyat Sorgula
              </Button>
            </Stack>
          </Box>
        )}
        {(fiyatSorgulandi || activeTab === 1) && (
          <>
            {/* Stepper başlıkları, tab gibi */}
            <Box sx={{ display: 'flex', gap: 3, mt: 4, mb: 3, maxWidth: '680px', width: '100%' }}>
              {steps.map((label, idx) => (
                <Box key={label} sx={{ flex: 1, textAlign: 'center' }}>
                  <Box
                    sx={{
                      borderBottom: '4px solid',
                      borderColor: activeStep >= idx ? '#DA3831' : '#ECEFF1',
                      pb: 0.5,
                      mb: 0.5,
                    }}
                  />
                  <Typography
                    sx={{
                      color: activeStep >= idx ? '#DA3831' : '#374151',
                      fontSize: 13,
                      mt: 0.5,
                    }}
                  >
                    {label}
                  </Typography>
                </Box>
              ))}
            </Box>
            <Box sx={{ mt: 3, maxWidth: '680px', width: '100%' }}>
              {renderStepContent(activeStep)}
            </Box>
          </>
        )}
      </Box>
      <Box sx={{ width: '100%', maxWidth: '260px', backgroundColor: '#F4F4F4', padding: 2, borderRadius: 2, maxHeight: 650 }}>
        {/* Fiyat sorgulama yapılmadan önce boş panel */}
        {!fiyatSorgulandi ? (
          <></>
        ) : (
          selectedServiceObj && <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" color="#344054">Ücret detayları</Typography>
            <Typography variant="h5" color="#DA3831" fontWeight="bold" mt={1}>{selectedServiceObj.totalPrice[0].priceCurrency} {selectedServiceObj.totalPrice[0].price}</Typography>

            <Select
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
              fullWidth
              sx={{ mt: 1, mb: 1 }}
            >
              {apiProducts.map(p => (
                <MenuItem key={p.productName} value={p.productName}>
                  {p.productName}
                </MenuItem>
              ))}
            </Select>

            <Typography variant="body2" color="#888">Tahmini Teslimat Tarihi</Typography>
            <Typography variant="body2" color="#DA3831" fontWeight="bold">{new Date(selectedServiceObj.deliveryCapabilities.estimatedDeliveryDateAndTime).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}<br />{selectedServiceObj.deliveryCapabilities.deliveryTypeCode}</Typography>
            <Box sx={{
              marginTop: 2,
              marginBottom: 1,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}>
              <Typography variant="body2" fontWeight="500" fontSize="13px">Öğe</Typography>
              {selectedServiceObj.detailedPriceBreakdown[0].breakdown.map(d => (
                <Typography key={d.name} variant="body2" display="flex" justifyContent="space-between" fontWeight="500" fontSize="13px">
                  <span>{d.name}</span>
                  <span>{d.price}</span>
                </Typography>
              ))}
            </Box>
            <TextField label="Promosyon Kodu" fullWidth size="small" sx={{ mb: 1 }} />
            <Button variant="contained" color="inherit" disabled fullWidth sx={{ width: "100%", maxWidth: 108, mb: 2, ml: "auto", color: '#888', background: '#ECE8E8', alignSelf: "flex-end" }}>Uygula</Button>
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Typography variant="body2">Toplam</Typography>
              <Box textAlign="right">
                <Typography variant="body2" fontWeight="bold">{selectedServiceObj.totalPrice.find(p => p.priceCurrency === 'TRY')?.price} {selectedServiceObj.totalPrice.find(p => p.priceCurrency === 'TRY')?.priceCurrency}</Typography>
                <Typography variant="body2" color="#DA3831" fontWeight="bold">{selectedServiceObj.totalPrice.find(p => p.priceCurrency === 'EUR')?.price} {selectedServiceObj.totalPrice.find(p => p.priceCurrency === 'EUR')?.priceCurrency}</Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <Dialog open={paymentModalOpen} onClose={() => !iframeSrc && setPaymentModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Ödeme Bilgileri</DialogTitle>
        <DialogContent>
          {iframeSrc ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
              <iframe src={iframeSrc} title="3D Secure" style={{ width: "100%", height: "500px", border: "none" }} />
            </Box>
          ) : paymentTokenLoading ? (
            <Box py={4} textAlign="center"><CircularProgress /></Box>
          ) : paymentTokenError ? (
            <Box py={4} color="error.main" textAlign="center">{paymentTokenError}</Box>
          ) : (
            <Stack spacing={2} mt={1}>
              <TextField label="Kart Üzerindeki İsim" fullWidth value={cardName} onChange={e => setCardName(e.target.value)} error={!!paymentFormErrors.cardName} helperText={paymentFormErrors.cardName} />
              <TextField label="Kart Numarası" fullWidth value={cardNumber} onChange={handleCardNumberChange} placeholder="0000 0000 0000 0000" inputProps={{ maxLength: 19 }} error={!!paymentFormErrors.cardNumber} helperText={paymentFormErrors.cardNumber} />
              <Stack direction="row" spacing={2}>
                <TextField label="Son Kullanma Tarihi" fullWidth value={expiredDate} onChange={handleExpiryDateChange} placeholder="AA/YY" inputProps={{ maxLength: 5 }} error={!!paymentFormErrors.expiredDate} helperText={paymentFormErrors.expiredDate} />
                <TextField label="CVV" fullWidth value={cvv} onChange={handleCvvChange} placeholder="123" inputProps={{ maxLength: 3 }} error={!!paymentFormErrors.cvv} helperText={paymentFormErrors.cvv} />
              </Stack>
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          {!iframeSrc && (
            <>
              <Button onClick={() => setPaymentModalOpen(false)}>İptal</Button>
              <Button onClick={handleProceedToPayment} variant="contained" disabled={paymentTokenLoading || !!paymentTokenError}>
                Ödemeyi Tamamla
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* YENİ: Hata Modalı */}
      <Dialog open={showErrorModal} onClose={() => setShowErrorModal(false)}>
        <DialogTitle>Bir Sorun Oluştu</DialogTitle>
        <DialogContent>
          <Typography>{errorMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowErrorModal(false)}>Kapat</Button>
        </DialogActions>
      </Dialog>

      {/* YENİ: Sipariş Oluşturuluyor Yükleniyor Modalı */}
      <Dialog open={orderLoading}>
        <DialogContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <CircularProgress />
          <Typography>Siparişiniz oluşturuluyor, lütfen bekleyin...</Typography>
        </DialogContent>
      </Dialog>

    </Box>
  );
}